exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inTotal[data-v-5f620553]{margin:0;line-height:32px;margin-right:14px}.title[data-v-5f620553]{font-size:16px;font-weight:500}\n", ""]);

// exports
